import { AsyncPipe, DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { GEO_API_SERVICE_TOKEN, PERSON_API_SERVICE_TOKEN } from '@nk/api-lib';
import { PersonFlagEntity } from '@nk/data-entities-lib';
import { PersonFlagIconComponent } from '@nk/person-block';
import { NormalCasePipe, SpinnerComponent } from '@nk/ui-lib';
import { DateFormats } from '@nk/utils-lib';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { ScreeningCardListDetailsInputData } from '../../utils/screening.utils';

type PersonCommonInfoInputData = Pick<
  ScreeningCardListDetailsInputData,
  | 'uuid'
  | 'type'
  | 'birth_date'
  | 'birth_year'
  | 'national_identification_schema'
  | 'street_address'
  | 'postal_code'
  | 'postal_place'
  | 'municipality_name'
  | 'country_name'
>;

@Component({
  selector: 'nk-person-common-info',
  imports: [AsyncPipe, DatePipe, TranslateModule, SpinnerComponent, NormalCasePipe, PersonFlagIconComponent],
  templateUrl: './person-common-info.component.html',
  styleUrls: ['./person-common-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PersonCommonInfoComponent implements OnInit {
  public inputData = input.required<PersonCommonInfoInputData | null>();
  public country$!: Observable<string | undefined>;
  public flags$!: Observable<PersonFlagEntity[]>;
  public dateFormats = DateFormats;
  private _geoService = inject(GEO_API_SERVICE_TOKEN);
  private _personService = inject(PERSON_API_SERVICE_TOKEN);

  public ngOnInit(): void {
    const inputData = this.inputData();
    if (inputData) {
      this.country$ = this._geoService.geoCountryListCache
        .getStableCache()
        .pipe(
          map(
            (data) => data.find((i) => i.country_code_two === inputData?.national_identification_schema)?.country_name,
          ),
        );
      if (inputData.type === 'person') {
        this.flags$ = this._personService.personFlagListByPersonCache.get(inputData.uuid);
      } else {
        this.flags$ = of([]);
      }
    }
  }
}
